export default "__VITE_ASSET__B1ltdFlM__"